import { Button } from 'react-bootstrap';
import './styles/AudioComponent.scss';
import { regenerateAudio } from '@/features/orders/ordering/services/orderMediaService.js';
import { useState } from 'react';
import TextInput from './TextInput.js';
import LoadingIndicator from './LoadingIndicator.js';
import { TEXT_TYPE } from '../constants/constants.js';

const AudioComponent = ({
  audio,
  index,
  client_id,
  url,
  blank,
  batch_id,
  audio_text_type,
}) => {
  const [new_sentence_text, setNewSentenceText] = useState(
    !blank ? audio.sentence_txt : ''
  );
  const [audioUrl, setAudioUrl] = useState(!blank ? audio.audio_AI_url : url);
  const [isLoading, setIsLoading] = useState(false);

  const handleRegenerate = async (
    audio_id,
    new_sentence_text,
    text_type,
    client_id,
    blank
  ) => {
    setIsLoading(true);
    try {
      const response = await regenerateAudio(
        batch_id,
        audio_id,
        new_sentence_text,
        text_type,
        client_id,
        blank
      );
      setAudioUrl(response.data.url);
      setNewSentenceText(new_sentence_text);
      setIsLoading(false);
    } catch (error) {
      console.error('重新生成失败', error);
    } finally {
      setIsLoading(false); // 无论成功还是失败，都关闭加载状态
    }
  };

  return (
    <div key={index} className="file-preview-audio-component">
      <div className="file-container-audio-component">
        {isLoading ? (
          <LoadingIndicator />
        ) : (
          audioUrl && (
            <audio controls>
              <source src={audioUrl} type="audio/mpeg" />
              您的浏览器不支持音频元素。
            </audio>
          )
        )}
      </div>

      <div className="file-description-container-audio-component">
        <div className="description-container-audio-component">
          {new_sentence_text && !blank && (
            <>
              <div className="audio-component-container">
                <div className="description-title-container-audio-component">
                  <span className="description-title-audio-component">
                    声音文本
                  </span>
                </div>
                <TextInput
                  className="form-control-audio-component"
                  type="text"
                  value={new_sentence_text}
                  onChange={(e) => setNewSentenceText(e.target.value)}
                  disabled={false}
                  placeholder={'音频描述'}
                />
              </div>
              <Button
                variant="primary"
                className="confirm-button-audio-component"
                onClick={() => {
                  handleRegenerate(
                    audio.id,
                    new_sentence_text,
                    audio_text_type,
                    client_id,
                    false
                  );
                }}
              >
                重新生成
              </Button>
            </>
          )}
          {blank && (
            <>
              <div className="audio-component-container">
                <TextInput
                  className="form-control-audio-component"
                  type="text"
                  value={new_sentence_text}
                  onChange={(e) => setNewSentenceText(e.target.value)}
                  disabled={false}
                  placeholder={'音频描述'}
                />
              </div>

              <div className="regenerateBtns-container">
                <Button
                  variant="primary"
                  className="confirm-button-audio-component"
                  onClick={() => {
                    handleRegenerate(
                      '',
                      new_sentence_text,
                      TEXT_TYPE.SPEECH,
                      client_id,
                      true
                    );
                  }}
                >
                  生成致辞
                </Button>
                <Button
                  variant="primary"
                  className="confirm-button-audio-component"
                  onClick={() => {
                    handleRegenerate(
                      '',
                      new_sentence_text,
                      TEXT_TYPE.FAREWELL,
                      client_id,
                      true
                    );
                  }}
                >
                  生成告别
                </Button>
              </div>
            </>
          )}
        </div>
      </div>
      <hr className="divider" />
    </div>
  );
};

export default AudioComponent;
